// extracted by mini-css-extract-plugin
export default {"iconImg":"dashboard_iconImg__2Ow38"};